// extracted by mini-css-extract-plugin
module.exports = {"section":"BlogHero_section__NdVkR","subtitle":"BlogHero_subtitle__nW97x"};